import api from "../api";

export const hearingTokensService = {
  getOneByHearingFileId: async (hearingFileId: number) => {
    try {
      const { data } = await api.get(
        `/v1/HearingTokens/GetByHearingFileId?hearingFileId=${hearingFileId}`,
      );

      return {
        success: true,
        body: data.data,
      };
    } catch (error) {
      return {
        success: false,
        body: {},
      };
    }
  },
};
